import * as React from 'react'
import { CSSProperties } from 'react'
import ArrowCircleRightOutlined from '@mui/icons-material/ArrowCircleRightOutlined'

export type ArrowIconProps = {
  matched: boolean
  className?: string
  style: CSSProperties
}

export const ArrowIcon: React.FC<ArrowIconProps> = (props) => (
  <ArrowCircleRightOutlined
    className={props.className}
    style={{
      color: props.matched ? '#005AA3' : '#979797',
      width: 20,
      height: 20,
      ...props.style,
    }}
  />
)
ArrowIcon.displayName = 'ArrowIcon'
